import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="components--forms--match-list-item"
export default class extends Controller {
  static values = {
    observeKey: String
  }

  static classes = [
    "selected"
  ]

  static targets = [
    "item"
  ]

  connect() {
    document.addEventListener("turbo:frame-load", (event) => { this.observeItems(event) })
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", (event) => { this.observeItems(event) })
  }

  observeItems(event) {
    if (this.observeKeyValue == event.target.id) { this.setItemChoosen() }
  }

  itemTargetConnected() {
    this.setItemChoosen()
  }

  setItemChoosen() {
    this.itemTargets.forEach(item => {
      let form = document.querySelector("form[data-form-id='" + item.id + "']")
      if (form != null) {
        item.classList.add(...this.selectedClasses)
      } else {
        item.classList.remove(...this.selectedClasses)
      }
      return
    })
  }

  selected(event) {
    this.itemTargets.forEach(item => { item.classList.remove(...this.selectedClasses) })

    event.currentTarget.classList.add(...this.selectedClasses)
  }
}
